import { Form } from '@ps-design-system/components/Form';
import PropTypes from 'prop-types';
import React from 'react';
import { useCheckoutContext } from '../../CheckoutContextProvider';
import { IdentityVerificationField } from './IdentityVerificationField';

export const IdentityVerificationForm = ({ SSOid, intl, accessToken }) => {
  const { identityVerificationForm, bookingDetailsForm, listing } =
    useCheckoutContext();

  return (
    <Form
      spacing={0}
      testId="identity-verification-form"
      {...identityVerificationForm}
    >
      <IdentityVerificationField
        control={identityVerificationForm?.control}
        setFormValue={identityVerificationForm?.setValue}
        setFormError={identityVerificationForm?.setError}
        alcoholConsumed={bookingDetailsForm.watch('alcoholConsumed')}
        schedule={bookingDetailsForm.watch('schedule')}
        listing={listing}
        SSOid={SSOid}
        accessToken={accessToken}
        intl={intl}
      />
    </Form>
  );
};

IdentityVerificationForm.displayName = 'IdentityVerificationForm';
IdentityVerificationForm.propTypes = {
  SSOid: PropTypes.string,
  accessToken: PropTypes.string,
  intl: PropTypes.object
};
